<div class="restrict-trigger-domains-dialog">
  <app-popup-top-line></app-popup-top-line>
  <div class="restrict-trigger-domains-dialog-header">
    <div class="title">
      Restrict Trigger Domains
      <div class="description">
        Define and enforce specific email domains authorized to trigger the agent, ensuring greater control and
        minimizing unauthorized access.
      </div>
    </div>
    <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="restrict-trigger-domains-dialog-body">
    <div class="email-input">
      <form [formGroup]="domainForm" (ngSubmit)="saveDomains()">
        <label for="domains">Enter domain names (separated by `;`):</label>
        <textarea
          id="domains"
          formControlName="domainInput"
          rows="5"
          placeholder="e.g., example.com; example.org"
        ></textarea>
        <div *ngIf="domainInput?.invalid && domainInput?.touched" class="error">Please enter valid domain names.</div>
        <!-- <button type="submit" [disabled]="domainForm.invalid">Save Domains</button> -->
      </form>

      <!--
            <div *ngIf="savedEmails.length > 0" class="saved-emails">
              <h3>Saved Emails:</h3>
              <ul>
                <li *ngFor="let email of savedEmails">{{ email }}</li>
              </ul>
            </div>

        -->
    </div>
  </div>

  <br /><br /><br />
  <div class="restrict-trigger-domains-dialog-footer">
    <div class="restrict-trigger-domains-dialog-buttons-container">
      <div class="footer">
        <button type="button" class="footer-button" (click)="onCreateIncidentClick()" [disabled]="domainForm.invalid">
          <span *ngIf="!waitingForResponse">Apply</span>
          <mat-progress-spinner
            class="spinner"
            *ngIf="waitingForResponse"
            color="primary"
            mode="indeterminate"
          ></mat-progress-spinner>
        </button>
      </div>
    </div>
  </div>
</div>
